module.exports = __webpack_public_path__ + "static/media/adidas.c90dbb3f.jpeg";